import styled, { css } from 'styled-components';

import {
    Adornment,
    token,
    Input,
    spaceMixin,
    mediaMixin,
} from '@zillow/constellation';

export const StyledSpacer = styled.div`
    width: ${spaceMixin('md')};
    height: ${spaceMixin('md')};
`;

export const StyledAddAmenityInput = styled(Input)`
    width: 100%;

    /* 480 */
    ${mediaMixin('md', css`
        width: 75%;
    `)}
`;

export const StyledAdornment = styled(Adornment)`
    && {
        &:focus {
            background-color: ${token('colors.coolGray100')};
            border-color: ${token('colors.coolGray100')};
            box-shadow: none;
        }
    }
`;
